/* WALLTRAUD®: Montagewahl als Shopify line-item property, ohne zusätzliche Varianten. */
(() => {
  'use strict';
  if (window.__wtMountChoiceReady) return;
  window.__wtMountChoiceReady = true;

  const key = 'properties[Montageuntergrund]';
  const allowed = ['Normale Wand', 'Akustikpaneele'];
  const selectedByProduct = new Map();
  const mountForm = 'form[data-wt-mount-required="true"]';
  const mountingChoice = '[data-wt-mount-choice]';
  const gate = '[data-wt-mount-gate]';
  let pendingScan = false;

  function productId(form) { return form.dataset.productId || ''; }
  function checkedValue(form) {
    const checked = form.querySelector(`${mountingChoice} input[name="${key}"]:checked`);
    return checked && allowed.includes(checked.value) ? checked.value : '';
  }
  function sourceValue(form) {
    if (form.querySelector(mountingChoice)) return checkedValue(form);
    return selectedByProduct.get(productId(form)) || '';
  }
  function formAvailable(form) {
    const variantIdInput = form.querySelector('input[name="id"].product-variant-id');
    if (variantIdInput && variantIdInput.disabled) return false;
    const button = form.querySelector(gate);
    if (button && button.dataset.wtMountStock === 'false') return false;
    return true;
  }
  function updateForm(form) {
    const choice = form.querySelector(mountingChoice);
    const btn = form.querySelector(gate);
    const id = productId(form);
    if (!btn) return;
    if (choice && id && !checkedValue(form) && selectedByProduct.has(id)) {
      const value = selectedByProduct.get(id);
      const radio = Array.from(choice.querySelectorAll('input[type="radio"]')).find(i => i.value === value);
      if (radio) radio.checked = true;
    }
    const selected = sourceValue(form);
    const available = formAvailable(form);
    const shouldDisable = !selected || !available;
    if (btn.disabled !== shouldDisable) btn.disabled = shouldDisable;
    // FoxTheme prüft hasAttribute('aria-disabled') vor jedem AJAX-Warenkorb-Submit.
    // Auch aria-disabled="false" BLOCKIERT dort das Hinzufügen!
    // Das Attribut daher nur bei wirklicher Sperre setzen und nach der Auswahl entfernen.
    // Während einer laufenden AJAX-Anfrage verwaltet das Theme es selbst.
    if (shouldDisable) {
      btn.setAttribute('aria-disabled', 'true');
    } else if (!btn.classList.contains('btn--loading')) {
      btn.removeAttribute('aria-disabled');
    }

    if (choice) {
      choice.toggleAttribute('data-wt-selected', !!selected);
      const feedback = choice.querySelector('[data-wt-mount-feedback]');
      if (feedback) {
        const message = selected ? 'Passendes Montagematerial wird beigelegt.' : 'Bitte Montageuntergrund auswählen.';
        if (feedback.textContent !== message) feedback.textContent = message;
      }
      if (selected) choice.removeAttribute('data-wt-error');
    }
    const stickyProperty = form.querySelector('[data-wt-mount-sticky-property]');
    if (stickyProperty) {
      stickyProperty.value = selected;
      stickyProperty.disabled = !selected;
    }
  }
  function scan() {
    const forms = Array.from(document.querySelectorAll(mountForm));
    // Bereits ausgewählte Radiofelder erhalten (auch nach Shopify Abschnitts-Updates).
    forms.forEach(form => {
      const value = checkedValue(form);
      if (value && productId(form)) selectedByProduct.set(productId(form), value);
    });
    forms.forEach(updateForm);
  }
  function scheduleScan() {
    if (pendingScan) return;
    pendingScan = true;
    requestAnimationFrame(() => { pendingScan = false; scan(); });
  }
  function errorAndFocus(form) {
    const choice = form.querySelector(mountingChoice) ||
      Array.from(document.querySelectorAll(`${mountForm} ${mountingChoice}`)).find(x => x.closest('form')?.dataset.productId === productId(form));
    if (choice) {
      choice.setAttribute('data-wt-error', '');
      choice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => choice.querySelector('input')?.focus({ preventScroll: true }), 250);
    }
  }
  document.addEventListener('change', e => {
    if (!e.target.matches(`${mountingChoice} input[name="${key}"]`)) return;
    const form = e.target.closest(mountForm);
    if (!form || !allowed.includes(e.target.value)) return;
    const id = productId(form);
    if (id) selectedByProduct.set(id, e.target.value);
    scan();
  });

  // Sicherheitsschicht gegen Enter-Taste, native Submit- und Theme-AJAX-Pfade.
  // Ein deaktivierter Button ist alleine kein ausreichender Submit-Schutz.
  document.addEventListener('submit', e => {
    const form = e.target;
    if (!form.matches?.(mountForm)) return;
    const selected = sourceValue(form);
    if (!selected || !allowed.includes(selected)) {
      e.preventDefault(); e.stopImmediatePropagation(); errorAndFocus(form); return;
    }
    const prop = form.querySelector('[data-wt-mount-sticky-property]');
    if (prop) { prop.value = selected; prop.disabled = false; }
  }, true);

  // In FoxTheme werden Formularteile bei Variantenwechsel und Quick View neu eingefügt.
  // Das Auswahlfeld und die Sperre dort jedes Mal synchron halten.
  const obs = new MutationObserver(mutations => {
    if (mutations.some(m => m.type === 'childList' ||
      (m.type === 'attributes' && m.target.matches?.(gate)))) scheduleScan();
  });
  function start() {
    scan();
    obs.observe(document.body, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled']});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
